
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationNewFormButton: {
    id: "ConfigurationNewForm.button",
    defaultMessage: "Accept",
  }, 
});

export default MESSAGES;